import { useEffect, useMemo } from 'react';

// Zustand store
import { useShallow } from 'zustand/react/shallow';
import { useDepartmentsStore, useUserStore } from 'storeZustand';

const useSelectedDepartment = () => {
	// id департамента
	const departmentId = JSON.parse(localStorage.getItem('user'))?.state?.departmentId;

	// Загрузка данных текущего пользователя
	const [
		isSuperAdmin,
		isOstrovok,
		isCallCenter,
		getUser,
	] = useUserStore(useShallow((state) => [
		state.isSuperAdmin,
		state.isOstrovok,
		state.isCallCenter,
		state.getUser
	]));

	// Загрузка департаментов
	const [
		departments,
		getDepartments,
		setSelectedDepartment,
		selectedDepartment
	] = useDepartmentsStore((state) => [
		state.departments,
		state.getDepartments,
		state.setSelectedDepartment,
		state.selectedDepartment
	]);

	// Список городов для селекта
	const departmentsData = useMemo(() => {
		return departments?.map(({ id, name, city, address }) => ({
			value: id,
			label: `${name}, ${city}, ${address}`,
		})) ?? [];
	}, [departments]);

	// 2 департамента только для островка
	const filteredOstrovokDepartment = departmentsData.filter((item) => item.value === 1 || item.value === departmentId);

	// Отфильтрованный департамент для обычных сотрудников
	const filteredDepartment = departmentsData.filter((item) => item.value === departmentId);

	// Разрешенные департаменты
	const authorizedDepartments = useMemo(() => {
		if (isSuperAdmin || isCallCenter) {
			// Администратору разрешено видеть все отделы
			return departmentsData;
		} else if (isOstrovok) {
			// Сотруднику Ostrovok разрешено видеть 2 отдела
			return filteredOstrovokDepartment;
		} else {
			// Всем остальным показываем только его отдел
			return filteredDepartment;
		}
	}, [isSuperAdmin, isOstrovok, departmentsData, filteredOstrovokDepartment, filteredDepartment, isCallCenter]);

	useEffect(() => {
		getUser(); // запрос данных пользователя
		getDepartments();// Запрос всех департаментов
	}, []);

	// Сохранение выбранного департамента
	useEffect(() => {
		if (!isSuperAdmin && !isOstrovok && !isCallCenter) {
			setSelectedDepartment(departmentId);
		}

		// По умолчанию стоит Питер
		if (isSuperAdmin) {
			setSelectedDepartment(1);
		}

		if (isCallCenter) {
			setSelectedDepartment(9);
		}
	}, [departmentId, isSuperAdmin, isOstrovok]);

	// Изменение департамента в селекте
	const handleSelectedDepartment = (value) => {
		setSelectedDepartment(value);
	}

	return {
		authorizedDepartments,
		selectedDepartment,
		handleSelectedDepartment,
	};
};

export default useSelectedDepartment;
